import { Component, Input, OnInit } from '@angular/core'
import { ParkingService } from '../../../services/parking.service'
import { merchantParkingsPath, Parking, ParkingStatus, ParkingType } from '@parkupp/core'
import { Router } from '@angular/router'
import { collection, collectionData } from '@angular/fire/firestore'

@Component({
    selector: 'app-merchant-parking-list',
    templateUrl: './merchant-parking-list.component.html',
    styleUrls: ['./merchant-parking-list.component.scss'],
})
export class MerchantParkingListComponent implements OnInit {
    @Input() merchantKey: string

    loading = false
    error: string
    parkings: Parking[] = []

    constructor(private router: Router, private parkingSvc: ParkingService) {}

    ngOnInit(): void {
        collectionData(collection(this.parkingSvc.firestore, merchantParkingsPath(this.merchantKey)), { idField: 'documentId' }).subscribe((documents: any[]) => {
            const parkings: Parking[] = []
            documents.forEach((documentData) => {
                let parking: Parking = documentData as any
                parking.$key = documentData.documentId
                if (parking.parkingStatus != ParkingStatus.DISABLED) {
                    parkings.push(parking)
                }
            })
            this.parkings = parkings
        })
    }

    onSelect(parking: Parking) {
        if (parking.parkingType != ParkingType.BOOKING) {
            this.router.navigate([`merchant/${this.merchantKey}/parking/${parking.$key}`])
        }
    }
}
